import { TrackingHistoryService } from './../../../common-components/tracking-history/service/tracking-history.service';
import { Component, Inject, Input, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { FormGroupDirective, UntypedFormGroup, UntypedFormBuilder, Validators, UntypedFormControl } from '@angular/forms';
import { MatDialogRef, MatDialog, MAT_DIALOG_DATA, MatDialogConfig } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { Subscription } from 'rxjs';
import { EnrollmentPeriods } from 'src/app/component/common-components/child-services/model/enrollment-periods.model';
import { HelpTextComponent } from 'src/app/component/common-components/help-text/help-text.component';
import { MsgModel } from 'src/app/component/common-components/msg/model/msg.model';
import { PartyServices } from 'src/app/component/service-administration/model/party-services.model';
import { ServiceHourRanges } from 'src/app/component/service-administration/model/service-hour-ranges.model';
import { County } from 'src/app/model/county';
import { QuestionHelpText } from 'src/app/model/question-help-text';
import { Region } from 'src/app/model/region.model';
import { School, Grade } from 'src/app/model/school.model';
import { SchoolDistrict } from 'src/app/model/schoolDistrict.model';
import { Student } from 'src/app/model/student/student.model';
import { CleanDatePipe } from 'src/app/pipes/clean-date.pipe';
import { GetGradeByNamePipe } from 'src/app/pipes/get-grade-object.pipe';
import { GetPropertyPipe } from 'src/app/pipes/get-property.pipe';
import { SimpleDatePipe } from 'src/app/pipes/simple-date.pipe';
import Swal from 'sweetalert2';
import { CosReasons } from '../../model/cos-reasons.model';
import { SchoolEnrollmentDetailsAsl } from '../../model/school-enrollment-details-asl.model';
import { ServiceDeliveries } from '../../model/service-deliveries.model';
import { ServiceDeliveryService } from '../../service-delivery/service/service-delivery.service';
import { StudentEligibilitiesService } from '../../service/student-eligibilities.service';
import { EditChildModalComponent } from '../edit-child-modal-btn/edit-child-modal/edit-child-modal.component';
import { UserProfileService } from 'src/app/component/user-profile/service/user-profile.service';
import { User } from 'src/app/component/auth/model/user.model';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort, Sort } from '@angular/material/sort';
import { EnrollmentReportStudent } from 'src/app/component/child-reports/enrollment-report/model/enrollment-report-result.model';

@Component({
    selector: 'app-edit-child-group-service-participation',
    templateUrl: './edit-child-group-service-participation.component.html',
    styleUrls: ['./edit-child-group-service-participation.component.scss']
})
export class EditChildGroupServiceParticipationComponent {
    @Input() students!: any[];
    studentServices: any[] = [];

    title: string;
    user: User;
    uniqueStudents: any[] = [];
    studentLength: number = 0;

    @ViewChildren(MatPaginator) paginators: QueryList<MatPaginator> = new QueryList<MatPaginator>();
    @ViewChildren(MatSort) sorts: QueryList<MatSort> = new QueryList<MatSort>();

    @ViewChild('serviceParticipationForm') childInfoForm: FormGroupDirective;
    form: UntypedFormGroup;

    // Reference Data
    cosReasons: CosReasons[];
    enrollmentPeriods: EnrollmentPeriods[];
    schoolEnrollments: any[] = [];
    missingEoEStudents: Student[];

    selectedSchoolYear: string = ''; // to hold actual school year value
    selectSchoolYear: string = ''; // for initial edit
    chosenRegion: Region;
    chosenCounty: County;
    chosenCountyName: string;
    chosenSchoolDistrict: SchoolDistrict;
    chosenSchoolDistrictName: string;
    chosenSchool: School;
    chosenSchoolName: string;
    chosenGrades: Grade[] = [];
    chosenGrade: Grade;
    chosenSchoolEnrollment: any;
    chosenEnrollmentPeriods: EnrollmentPeriods[] = [];

    // Service Participation Data
    selectRegionIds: number[] = [];
    selectCountyIds: number[] = [];
    selectSchoolDistrictIds: number[] = [];
    selectSchoolIds: number[] = [];
    selectServices: PartyServices[] = [];
    chosenServices: PartyServices[] = [];
    chosenServiceHoursRequired: PartyServices[] = [];
    // Grade?
    // Service Period ?
    // Services ?

    // Date options
    maxEndOfEligibilityStudent?: Student;
    maxTerminationStudent?: Student;
    restrictedDateOptions = {
        minDate: new Date(),
        maxDate: new Date()
    };
    startDateOptions = {
        defaultMinDate: new Date(),
        defaultMaxDate: new Date(),
        minDate: new Date(),
        maxDate: new Date(),
        startAt: new Date()
    };
    endDateOptions = {
        defaultMinDate: new Date(),
        defaultMaxDate: new Date(),
        minDate: new Date(),
        maxDate: new Date(),
        startAt: new Date()
    };
    dateFlags: any[] = [];
    creationFlags: any[] = [];

    formChanges: any = {};

    // Selected Children Table
    selectedChildrenTableDataSource: MatTableDataSource<EnrollmentReportStudent>;
    selectedChildrenFilter: string = '';
    columns = {
        EDIT: { INDEX: 1, ENABLED: true, SORT: 'EDIT', DATA: 'EDIT', DISABLED: false },
        'MSD Number': { INDEX: 6, ENABLED: true, SORT: 'MSD_NUMBER', DATA: 'MSD_NUMBER', DISABLED: true },

        Name: { INDEX: 10, ENABLED: true, SORT: 'PERSON.LAST_NAME', DATA: 'PERSON.LAST_NAME', DISABLED: true },

        Grade: { INDEX: 20, ENABLED: true, SORT: 'SCHOOL_ENROLLMENT_DETAILS[0].GRADE', DATA: 'GRADE', DISABLED: true, SCHOOL_ENROLLMENT_DETAILS: true },
        'Enroll Type': {
            INDEX: 21,
            ENABLED: true,
            SORT: 'SCHOOL_ENROLLMENT_DETAILS[0].ENROLLMENT_TYPE',
            DATA: 'ENROLLMENT_TYPE',
            DISABLED: true,
            SCHOOL_ENROLLMENT_DETAILS: true
        },
        'Enroll Date': {
            INDEX: 27,
            ENABLED: true,
            SORT: 'SCHOOL_ENROLLMENT_DETAILS[0].ENROLLMENT_DATE',
            DATA: 'ENROLLMENT_DATE',
            DISABLED: true,
            SCHOOL_ENROLLMENT_DETAILS: true
        },
        'Withdrawal Date': {
            INDEX: 28,
            ENABLED: true,
            SORT: 'SCHOOL_ENROLLMENT_DETAILS[0].WITHDRAWAL_DATE',
            DATA: 'WITHDRAWAL_DATE',
            DISABLED: true,
            SCHOOL_ENROLLMENT_DETAILS: true
        },
        EoE: {
            INDEX: 29,
            ENABLED: true,
            SORT: 'SCHOOL_ENROLLMENT_DETAILS[0].STUDENT_ELIGIBILITIES[0].ELIGIBILITY_END_DATE',
            DATA: 'STUDENT_ELIGIBILITIES[0].ELIGIBILITY_END_DATE',
            DISABLED: true,
            SCHOOL_ENROLLMENT_DETAILS: true
        }
    };
    selectedChildrenDisplayedColumns: string[] = [];

    // Table display for current changes
    displayedColumns: string[] = ['CHANGED_FIELD', 'VALUE', 'CHANGED_VALUE'];

    // Table results for current changes
    tableDataSource: MatTableDataSource<any>;

    // Component variables
    resetField: boolean = false;

    loadingSchoolEnrollments: boolean = false;
    loadingSchoolEnrollmentsTimeout: NodeJS.Timeout;
    loadingChanges: boolean = false;
    isLoading: boolean = false;
    isLoadingGroup: boolean = false;
    isSaving: boolean = false;
    isSubmitting: boolean = false;

    promises: Array<any> = [];

    msg: MsgModel;
    errorMsg: MsgModel;

    // Help Text
    lstQuestionHelpText: QuestionHelpText[] = [];

    // Pipes
    cleanDatePipe: CleanDatePipe = new CleanDatePipe();
    simpleDatePipe: SimpleDatePipe = new SimpleDatePipe();
    getPropertyPipe: GetPropertyPipe = new GetPropertyPipe();
    getGradeByNamePipe: GetGradeByNamePipe = new GetGradeByNamePipe();
    simpleDate(date: Date) {
        return date ? this.simpleDatePipe.transform(this.cleanDatePipe.transform(date)) : '';
    }

    // Subscriptions
    subs: Subscription[] = [];

    constructor(
        public dialogRef: MatDialogRef<EditChildModalComponent>,
        private dialog: MatDialog,
        @Inject(MAT_DIALOG_DATA) public data: any,
        private fb: UntypedFormBuilder,
        private serviceDeliveryService: ServiceDeliveryService,
        private studentEligibilitiesService: StudentEligibilitiesService,
        private trackingHistoryService: TrackingHistoryService,
        private userProfileService: UserProfileService
    ) {
        this.form = fb.group({
            startDate: [''],
            endDate: ['']
        });

        if (this.data.cosMode) {
            this.removeControl('schoolEnrollment');

            this.addControl('cosType');
        } else if (this.data.students.length > 1) {
            this.removeControl('schoolEnrollment');
        }

        this.subscriptions();
    }

    subscriptions() {
        let startDateSub = this.form.get('startDate')!.valueChanges.subscribe((changes) => {
            if (changes) {
                this.setEndDate(changes);
            }
        });

        this.subs.push(startDateSub);

        let formSub = this.form.valueChanges.subscribe(() => {
            let changes = this.form.getRawValue();
            Object.keys(changes).forEach((key) => {
                if (this.formChanges[key]) {
                    this.formChanges[key].CHANGED_VALUE = changes[key];
                } else if (!isNaN(parseInt(key))) {
                    // Service Hour are in IDs (number)
                    let serviceHourRange: ServiceHourRanges = changes[key];
                    if (serviceHourRange) {
                        this.formChanges['serviceHour'].CHANGED_VALUE =
                            serviceHourRange.MIN + (serviceHourRange.MAX ? ' - ' + serviceHourRange.MAX : ' +') + ' hour(s)';
                    } else {
                        this.formChanges['serviceHour'].CHANGED_VALUE = '';
                    }
                } else {
                }
            });

            this.updateDataSource();
        });
        this.subs.push(formSub);
    }

    ngOnDestroy(): void {
        this.subs.forEach((sub) => {
            sub.unsubscribe();
        });

        clearTimeout(this.loadingSchoolEnrollmentsTimeout);
    }

    ngOnInit(): void {
        this.isLoading = true;

        // Use data IDs if exists
        if (this.data) {
            this.students = this.data.students;
        }

        // Reference API calls
        this.getCOSResons();
        this.getEnrollmentPeriods();
        // this.getGradesTable();
        // this.getUserRegions();

        // Needed
        this.getUserProfile();
        this.getLatestCoeAndEligiblity(this.students);

        this.title = 'Updating Group Services for ' + this.students.length + ' child(ren)';
        this.displayedColumns = this.generateDisplayColumns();

        Promise.all(this.promises).then((res) => {
            setTimeout(() => {
                this.getStudentEnrollmentsBySchoolDestrictScYrV2();

                Promise.all(this.promises).then((res) => {
                    this.initNewGroupServiceDelivery();
                    this.isLoading = false;
                });
            }, 1000);
        });
    }

    generateDisplayColumns(prefixColumns?: string[]) {
        let displayedColumns: string[] = prefixColumns ? prefixColumns : [];
        let columns: any = this.columns;
        //displayedColumns = displayedColumns.concat(this.baseDisplayedColumns);

        const properties = Object.keys(columns);
        properties.forEach((property) => {
            if (columns[property].ENABLED) {
                displayedColumns.push(columns[property].SORT);
            }
        });

        return displayedColumns;
    }

    /*
     * API functions
     */
    getCOSResons() {
        let deferred = new Promise((resolve, reject) => {
            this.serviceDeliveryService.getCOSResons().subscribe((res) => {
                if (res.result) {
                    this.cosReasons = res.result;
                    resolve(res);
                } else if (res?.msg) {
                    reject(res);
                } else {
                    reject('err');
                }
            });
        });

        this.promises.push(deferred);
    }

    getEnrollmentPeriods() {
        let deferred = new Promise((resolve, reject) => {
            this.serviceDeliveryService.getEnrollmentPeriods().subscribe((res) => {
                if (res.result) {
                    this.enrollmentPeriods = res.result.filter(
                        (ep: EnrollmentPeriods) => ep.PERIOD === 'Regular Year' || ep.PERIOD === 'Summer' || ep.PERIOD === 'Intersession'
                    );
                    resolve(res);
                } else if (res?.msg) {
                    reject(res);
                } else {
                    reject('err');
                }
            });
        });

        this.promises.push(deferred);
    }

    getLatestCoeAndEligiblity(students: Student[]) {
        let deferred = new Promise((resolve, reject) => {
            this.studentEligibilitiesService.getLatestCoeAndEligiblity(students).subscribe((res) => {
                if (res.students) {
                    this.missingEoEStudents = res.students;

                    this.setEligibilityAndTerminationRestrictions(this.missingEoEStudents);

                    resolve(res);
                } else if (res?.msg) {
                    resolve(res);
                } else {
                    reject('err');
                }
            });
        });

        this.promises.push(deferred);
    }

    getUserProfile() {
        let deferred = new Promise((resolve, reject) => {
            this.userProfileService.getMyProfile().subscribe((res) => {
                if (res?.user) {
                    this.user = res.user;

                    resolve(res);
                } else if (res?.msg) {
                    reject(res);
                } else {
                    reject('err');
                }
            });
        });
        this.promises.push(deferred);
    }

    getStudentEnrollmentsBySchoolDestrictScYrV2() {
        if (this.students && this.students.length > 0 && this.selectedSchoolYear && this.chosenRegion?.CODE) {
            if (!this.loadingSchoolEnrollments) {
                this.loadingSchoolEnrollments = true;
                let deferred = new Promise((resolve, reject) => {
                    let studentsSchoolYears: any[] = [];
                    this.students.forEach((student) => {
                        studentsSchoolYears.push({
                            regionCode: this.chosenRegion?.CODE,
                            schoolYear: this.selectedSchoolYear,
                            studentID: student.ID
                        });
                    });

                    this.serviceDeliveryService.getStudentEnrollmentsBySchoolDestrictScYrV2(studentsSchoolYears).subscribe((res) => {
                        if (res.schoolEnrollmentsString) {
                            this.schoolEnrollments = res.schoolEnrollmentsString;

                            this.schoolEnrollments.forEach((se) => {
                                if (se.EnrollmentDate) {
                                    se.EnrollmentDate = this.cleanDatePipe.transform(se.EnrollmentDate);
                                }
                                if (se.WithdrawalDate) {
                                    se.WithdrawalDate = this.cleanDatePipe.transform(se.WithdrawalDate);
                                }
                            });

                            this.loadingSchoolEnrollments = false;

                            resolve(res);
                        } else if (res?.msg) {
                            this.schoolEnrollments = [];
                            this.loadingSchoolEnrollments = false;
                            resolve(res);
                        } else {
                            this.schoolEnrollments = [];
                            this.loadingSchoolEnrollments = false;
                            reject('err');
                        }
                    });
                });

                this.promises.push(deferred);
            }
        }
    }

    /*
     * SUBMIT functions
     */
    submit() {
        if (this.checkValid()) {
            this.isSubmitting = true;
            this.msg = new MsgModel();

            this.promises = [];

            this.resolveOnlyChosenStudentServices().forEach((studentService: any) => {
                let deferred = new Promise((resolve, reject) => {
                    this.serviceDeliveryService.editServiceDeliveryDates(this.generatePayload(studentService)).subscribe({
                        next: (res) => {
                            if (res.msg) {
                                if (res.msg.SUCCESS) {
                                    resolve(res.msg);
                                } else {
                                    reject();
                                }
                            } else {
                                reject();
                            }
                        },
                        error: (err) => {
                            reject();
                        },
                        complete: () => {}
                    });
                });

                this.promises.push(deferred);

                let trackingHistoryDeferred = new Promise((resolve, reject) => {
                    this.trackingHistoryService.create(this.generateEditedFields(studentService)).subscribe({
                        next: (res) => {
                            if (res.msg) {
                                if (res.msg.SUCCESS) {
                                    resolve(res.msg);
                                } else {
                                    reject();
                                }
                            } else {
                                reject();
                            }
                        },
                        error: (err) => {
                            reject();
                        },
                        complete: () => {}
                    });
                });
                this.promises.push(trackingHistoryDeferred);
            });

            Promise.all(this.promises).then((res) => {
                setTimeout(() => {
                    this.msg = { MSG: 'Successfully updated dates. (closing modal in 3 seconds...)', SUCCESS: true };

                    this.dialogRef.close({ refresh: true });
                    this.isSubmitting = false;
                }, 1000);
            });
        }
    }

    checkValid() {
        this.form.markAllAsTouched();
        let valid = true;
        if (this.students.length === 1 || !this.hasAtLeastOneStudent()) {
            this.msg = { MSG: 'Please select at least one child.', SUCCESS: false };
            valid = false;
        } else if (!this.form.get('startDate')?.value && !this.form.get('endDate')?.value) {
            this.msg = { MSG: 'Please input a start or end date.', SUCCESS: false };
            valid = false;
        } else if (this.form.invalid) {
            this.msg = { MSG: 'Please input required fields', SUCCESS: false };
            valid = false;
        }

        setTimeout(() => {
            this.msg = undefined!;
        }, 7000);

        return valid;
    }

    // Payload generation
    generatePayload(studentService: any) {
        let serviceDelivery: ServiceDeliveries = new ServiceDeliveries();

        serviceDelivery.ID = studentService.STUDENT_SERVICE.ID;
        serviceDelivery.START_DATE = this.form.get('startDate')?.value;
        serviceDelivery.END_DATE = this.form.get('endDate')?.value;
        serviceDelivery.STUDENTS_ID = studentService.ID;

        return serviceDelivery;
    }

    generateEditedFields(studentService: any) {
        if (this.tableDataSource.filteredData) {
            if (this.tableDataSource.filteredData.length > 0) {
                let editedFields: any[] = [];

                this.tableDataSource.filteredData.forEach((data) => {
                    editedFields.push({
                        CHANGED_BY: this.user.USER_ID,
                        CHANGED_FORM: 'ServiceParticipation',
                        CHANGED_FORM_ID: studentService.STUDENT_SERVICE.ID,
                        CHANGED_FIELD: data.CHANGED_FIELD,
                        CHANGED_VALUE: data.VALUE
                    });
                });

                return { editedFields: editedFields };
            } else {
                return;
            }
        } else {
            return;
        }
    }

    initNewGroupServiceDelivery() {
        this.isLoadingGroup = true;
        this.restrictedDateOptions.minDate = undefined!;
        this.restrictedDateOptions.maxDate = undefined!;

        // Convert students array input to studentServices array (1 service per student object)
        this.students.forEach((student: any) => {
            student.STUDENT_SERVICES.forEach((service: any) => {
                let s: any = Object.keys(student).reduce((newObj: any, key) => {
                    if (!student[key].STUDENT_SERVICES) {
                        newObj[key] = student[key];
                    }

                    return newObj;
                }, {});

                s.STUDENT_SERVICE = JSON.parse(JSON.stringify(service));

                this.studentServices.push(s);
            });
        });

        // Set School Year
        this.selectedSchoolYear = this.studentServices[0].SCHOOL_ENROLLMENT_DETAILS[0].SCHOOL_YEAR;
        // Set Region
        this.chosenRegion = this.studentServices[0].REGION;

        // Set Service Period
        let servicePeriod = new EnrollmentPeriods();
        servicePeriod.ID = this.studentServices[0].STUDENT_SERVICE.ENROLLMENT_PERIODS_ID;
        if (servicePeriod.ID === 1) {
            servicePeriod.CODE = 'R';
        } else if (servicePeriod.ID === 2) {
            servicePeriod.CODE = 'S';
        } else if (servicePeriod.ID === 3) {
            servicePeriod.CODE = 'I';
        } else {
            servicePeriod.CODE = 'R';
        }
        this.chosenEnrollmentPeriods = [servicePeriod];

        // Try to find School Enrollment
        setTimeout(() => {
            this.getStudentEnrollmentsBySchoolDestrictScYrV2();
            Promise.all(this.promises).then((res) => {
                this.students.forEach((s) => {
                    s.ENABLED = true;
                });

                this.buildUniqueStudents();

                this.initCurrentChanges();
                this.setCurrentChanges();
                this.updateDataSource();
                this.checkGradeAndType();

                this.updateSelectedChildrenDataSource();

                this.studentLength = this.resolveOnlyChosenStudents().length;

                this.isLoadingGroup = false;
            });
        }, 1000);
    }

    checkGradeAndType() {
        this.restrictDates();
        this.setDates();
    }

    // Dialog function
    closeDialog(closed: boolean) {
        Swal.fire({
            titleText: 'Are you sure you want to continue without saving?',
            showDenyButton: false,
            showConfirmButton: true,
            showCancelButton: true,
            confirmButtonText: 'Continue',
            cancelButtonText: 'Go Back',
            icon: 'warning',
            confirmButtonColor: '#3a6b35'
        }).then((result: any) => {
            if (result.isConfirmed) {
                this.dialogRef.close();
            }
        });
    }

    getCurrentYear(year: string) {
        return year.substring(0, 4);
    }

    getNextYear(year: string) {
        var next = parseInt(year.substring(0, 4));
        next = next + 1;
        return next.toString();
    }

    dateFilter = (date: Date | null) => {
        if (date) {
            //return date.getMonth() % 2 == 1 && date.getDate() % 2 == 0
            //return date.getMonth() === new Date().getMonth() && date.getDate() === new Date().getDate();
            return true;
        } else {
            return false;
        }
    };

    addControl(name: string): void {
        this.form.addControl(name, new UntypedFormControl());

        this.form.get(name)?.addValidators([Validators.required]);
        this.form.get(name)?.updateValueAndValidity();
    }

    removeControl(name: string): void {
        this.form.removeControl(name);
        this.form.updateValueAndValidity();
    }

    /**************************************************************************************************************************
     * Date Filters
     **************************************************************************************************************************/
    restrictDates() {
        let allSchoolEnrollments: any[] = this.combineSchoolEnrollments();
        this.restrictedDateOptions.minDate = undefined!;
        this.restrictedDateOptions.maxDate = undefined!;

        // allSchoolEnrollments.push({
        //     ENROLLMENT_DATE: new Date('2023-08-10'),
        //     WITHDRAWAL_DATE: new Date('2023-09-10')
        // });

        allSchoolEnrollments.forEach((se) => {
            if (se.ENROLLMENT_DATE) {
                if (!this.restrictedDateOptions.minDate) {
                    this.restrictedDateOptions.minDate = se.ENROLLMENT_DATE;
                } else if (se.ENROLLMENT_DATE > this.restrictedDateOptions.minDate) {
                    this.restrictedDateOptions.minDate = se.ENROLLMENT_DATE;
                }
            }
            if (se.WITHDRAWAL_DATE) {
                if (!this.restrictedDateOptions.maxDate) {
                    this.restrictedDateOptions.maxDate = se.WITHDRAWAL_DATE;
                } else if (se.WITHDRAWAL_DATE < this.restrictedDateOptions.maxDate) {
                    this.restrictedDateOptions.maxDate = se.WITHDRAWAL_DATE;
                }
            }
        });
    }

    combineSchoolEnrollments() {
        let allSchoolEnrollments: any[] = [];

        // Add School Enrollments from students (from Group Services)
        if (this.students.length > 1) {
            this.resolveOnlyChosenStudents().forEach((s: any) => {
                if (s.SCHOOL_ENROLLMENT_DETAILS) {
                    let schoolEnrollmentDetails: SchoolEnrollmentDetailsAsl = new SchoolEnrollmentDetailsAsl();
                    schoolEnrollmentDetails.ID = s.SCHOOL_ENROLLMENT_DETAILS[0].ID;
                    schoolEnrollmentDetails.ENROLLMENT_DATE = this.cleanDatePipe.transform(s.SCHOOL_ENROLLMENT_DETAILS[0].ENROLLMENT_DATE);
                    schoolEnrollmentDetails.WITHDRAWAL_DATE = this.cleanDatePipe.transform(s.SCHOOL_ENROLLMENT_DETAILS[0].WITHDRAWAL_DATE);

                    allSchoolEnrollments.push(schoolEnrollmentDetails);
                }
            });
        } else if (this.students && this.students.length > 0) {
            this.students.forEach((s) => {
                if (s.SCHOOL_ENROLLMENT_DETAILS) {
                    let schoolEnrollmentDetails: SchoolEnrollmentDetailsAsl = new SchoolEnrollmentDetailsAsl();
                    schoolEnrollmentDetails.ID = s.SCHOOL_ENROLLMENT_DETAILS[0].ID;
                    schoolEnrollmentDetails.ENROLLMENT_DATE = this.cleanDatePipe.transform(s.SCHOOL_ENROLLMENT_DETAILS[0].ENROLLMENT_DATE);
                    schoolEnrollmentDetails.WITHDRAWAL_DATE = this.cleanDatePipe.transform(s.SCHOOL_ENROLLMENT_DETAILS[0].WITHDRAWAL_DATE);

                    allSchoolEnrollments.push(schoolEnrollmentDetails);
                }
            });
        }

        return allSchoolEnrollments;
    }

    setEligibilityAndTerminationRestrictions(students: Student[]) {
        this.maxEndOfEligibilityStudent = undefined;
        this.maxTerminationStudent = undefined;
        students.forEach((student) => {
            let eoeDate = this.cleanDatePipe.transform(
                this.getPropertyPipe.transform(student, 'SCHOOL_ENROLLMENT_DETAILS[0].STUDENT_ELIGIBILITIES[0].ELIGIBILITY_END_DATE')
            );

            if (eoeDate) {
                if (!this.maxEndOfEligibilityStudent) {
                    this.maxEndOfEligibilityStudent = student;
                } else {
                    let currentEoE = this.cleanDatePipe.transform(
                        this.getPropertyPipe.transform(
                            this.maxEndOfEligibilityStudent,
                            'SCHOOL_ENROLLMENT_DETAILS[0].STUDENT_ELIGIBILITIES[0].ELIGIBILITY_END_DATE'
                        )
                    );

                    if (new Date(eoeDate) < new Date(currentEoE)) {
                        this.maxEndOfEligibilityStudent = student;
                    }
                }
            }

            let terminationID = this.getPropertyPipe.transform(student, 'STUDENT_TERMINATION_STATUSES[0].ID');
            let terminationDate = this.cleanDatePipe.transform(this.getPropertyPipe.transform(student, 'STUDENT_TERMINATION_STATUSES[0].STATUS_DATE'));
            let terminationTypeID = this.getPropertyPipe.transform(student, 'STUDENT_TERMINATION_STATUSES[0].STUDENT_TERMINATION_STATUS_TYPES.ID');

            if (terminationID) {
                if (!this.maxTerminationStudent && terminationTypeID !== 1) {
                    this.maxTerminationStudent = student;
                } else {
                    let currentTerminationDate = this.cleanDatePipe.transform(
                        this.getPropertyPipe.transform(this.maxTerminationStudent, 'STUDENT_TERMINATION_STATUSES[0].STATUS_DATE')
                    );

                    if (new Date(terminationDate) < new Date(currentTerminationDate) && terminationTypeID !== 1) {
                        this.maxTerminationStudent = student;
                    }
                }
            }
        });
    }

    setDates() {
        this.dateFlags = [];
        this.creationFlags = [];

        this.setStartDates();
        this.setEndDate();
    }

    setStartDates() {
        let currentYear: number = parseInt(this.selectedSchoolYear.substring(0, 4));
        let nextYear: number = currentYear + 1;
        let minDate: Date;
        let maxDate: Date;

        if (this.chosenEnrollmentPeriods && this.chosenEnrollmentPeriods.length > 0 && this.chosenEnrollmentPeriods[0].CODE === 'R') {
            this.startDateOptions.defaultMinDate = new Date(currentYear, 6, 1);
            this.startDateOptions.defaultMaxDate = new Date(nextYear, 7, 31);

            if (this.restrictedDateOptions.minDate) {
                if (this.restrictedDateOptions.minDate > new Date(currentYear, 6, 1)) {
                    minDate = this.restrictedDateOptions.minDate;
                } else {
                    minDate = new Date(currentYear, 6, 1);
                }
            } else {
                minDate = new Date(currentYear, 6, 1);
            }
            if (this.restrictedDateOptions.maxDate) {
                if (this.restrictedDateOptions.maxDate < new Date(nextYear, 7, 31)) {
                    maxDate = this.restrictedDateOptions.maxDate;
                } else {
                    maxDate = new Date(nextYear, 7, 31);
                }
            } else {
                maxDate = new Date(nextYear, 7, 31);
            }
        } else if (this.chosenEnrollmentPeriods && this.chosenEnrollmentPeriods.length > 0 && this.chosenEnrollmentPeriods[0].CODE === 'S') {
            this.startDateOptions.defaultMinDate = new Date(nextYear, 4, 15);
            this.startDateOptions.defaultMaxDate = new Date(nextYear, 7, 31);

            if (this.restrictedDateOptions.maxDate) {
                if (this.restrictedDateOptions.maxDate > new Date(nextYear, 4, 15)) {
                    minDate = this.restrictedDateOptions.maxDate;
                } else {
                    minDate = new Date(nextYear, 4, 15);
                }
            } else {
                minDate = new Date(nextYear, 4, 15);
            }
            maxDate = new Date(nextYear, 7, 31);
        } else if (this.chosenEnrollmentPeriods && this.chosenEnrollmentPeriods.length > 0 && this.chosenEnrollmentPeriods[0].CODE === 'I') {
            this.startDateOptions.defaultMinDate = new Date(currentYear, 6, 1);
            this.startDateOptions.defaultMaxDate = new Date(nextYear, 7, 31);

            if (this.restrictedDateOptions.minDate) {
                if (this.restrictedDateOptions.minDate > new Date(currentYear, 6, 1)) {
                    minDate = this.restrictedDateOptions.minDate;
                } else {
                    minDate = new Date(currentYear, 6, 1);
                }
            } else {
                minDate = new Date(currentYear, 6, 1);
            }
            maxDate = new Date(nextYear, 7, 31);
        } else {
            this.startDateOptions.defaultMinDate = new Date(currentYear, 6, 1);
            this.startDateOptions.defaultMaxDate = new Date(nextYear, 7, 31);
            minDate = new Date(currentYear, 6, 1);
            maxDate = new Date(nextYear, 7, 31);
        }

        if (this.maxEndOfEligibilityStudent && this.maxTerminationStudent) {
            let eoeDate = this.cleanDatePipe.transform(
                this.getPropertyPipe.transform(this.maxEndOfEligibilityStudent, 'SCHOOL_ENROLLMENT_DETAILS[0].STUDENT_ELIGIBILITIES[0].ELIGIBILITY_END_DATE')
            );
            let terminationDate = this.cleanDatePipe.transform(
                this.getPropertyPipe.transform(this.maxTerminationStudent, 'STUDENT_TERMINATION_STATUSES[0].STATUS_DATE')
            );

            if (eoeDate <= terminationDate) {
                if (eoeDate < maxDate) {
                    let studentName = this.getPropertyPipe.transform(this.maxEndOfEligibilityStudent, 'NAME')
                        ? this.getPropertyPipe.transform(this.maxEndOfEligibilityStudent, 'NAME')
                        : this.getPropertyPipe.transform(this.maxEndOfEligibilityStudent, 'PERSON.FIRST_NAME') +
                          ' ' +
                          this.getPropertyPipe.transform(this.maxEndOfEligibilityStudent, 'PERSON.LAST_NAME');
                    let msdNumber = this.maxEndOfEligibilityStudent.MSD_NUMBER;
                    maxDate = eoeDate;

                    this.dateFlags.push({
                        MIN_MAX: 'Maximum',
                        DATE_TYPE: 'Start Date',
                        TYPE: 'End of Eligibility',
                        DATE: eoeDate,
                        NAME: studentName,
                        MSD_NUMBER: msdNumber
                    });

                    if (eoeDate < minDate) {
                        this.creationFlags.push({
                            TYPE: 'End of Eligibility',
                            DATE: eoeDate,
                            NAME: studentName,
                            MSD_NUMBER: msdNumber
                        });
                    }
                }
            } else {
                if (terminationDate < maxDate) {
                    let studentName = this.getPropertyPipe.transform(this.maxTerminationStudent, 'NAME')
                        ? this.getPropertyPipe.transform(this.maxTerminationStudent, 'NAME')
                        : this.getPropertyPipe.transform(this.maxTerminationStudent, 'PERSON.FIRST_NAME') +
                          ' ' +
                          this.getPropertyPipe.transform(this.maxTerminationStudent, 'PERSON.LAST_NAME');
                    let msdNumber = this.maxTerminationStudent.MSD_NUMBER;
                    maxDate = terminationDate;

                    this.dateFlags.push({
                        MIN_MAX: 'Maximum',
                        DATE_TYPE: 'Start Date',
                        TYPE: 'Termination',
                        DATE: terminationDate,
                        NAME: studentName,
                        MSD_NUMBER: msdNumber
                    });

                    if (terminationDate < minDate) {
                        this.creationFlags.push({
                            TYPE: 'Termination',
                            DATE: terminationDate,
                            NAME: studentName,
                            MSD_NUMBER: msdNumber
                        });
                    }
                }
            }
        } else if (this.maxEndOfEligibilityStudent) {
            let eoeDate = this.cleanDatePipe.transform(
                this.getPropertyPipe.transform(this.maxEndOfEligibilityStudent, 'SCHOOL_ENROLLMENT_DETAILS[0].STUDENT_ELIGIBILITIES[0].ELIGIBILITY_END_DATE')
            );
            if (eoeDate < maxDate) {
                let studentName = this.getPropertyPipe.transform(this.maxEndOfEligibilityStudent, 'NAME')
                    ? this.getPropertyPipe.transform(this.maxEndOfEligibilityStudent, 'NAME')
                    : this.getPropertyPipe.transform(this.maxEndOfEligibilityStudent, 'PERSON.FIRST_NAME') +
                      ' ' +
                      this.getPropertyPipe.transform(this.maxEndOfEligibilityStudent, 'PERSON.LAST_NAME');
                let msdNumber = this.maxEndOfEligibilityStudent.MSD_NUMBER;
                maxDate = eoeDate;

                this.dateFlags.push({
                    MIN_MAX: 'Maximum',
                    DATE_TYPE: 'Start Date',
                    TYPE: 'End of Eligibility',
                    DATE: eoeDate,
                    NAME: studentName,
                    MSD_NUMBER: msdNumber
                });

                if (eoeDate < minDate) {
                    this.creationFlags.push({
                        TYPE: 'End of Eligibility',
                        DATE: eoeDate,
                        NAME: studentName,
                        MSD_NUMBER: msdNumber
                    });
                }
            }
        } else if (this.maxTerminationStudent) {
            let terminationDate = this.cleanDatePipe.transform(
                this.getPropertyPipe.transform(this.maxTerminationStudent, 'STUDENT_TERMINATION_STATUSES[0].STATUS_DATE')
            );
            if (terminationDate < maxDate) {
                let studentName = this.getPropertyPipe.transform(this.maxTerminationStudent, 'NAME')
                    ? this.getPropertyPipe.transform(this.maxTerminationStudent, 'NAME')
                    : this.getPropertyPipe.transform(this.maxTerminationStudent, 'PERSON.FIRST_NAME') +
                      ' ' +
                      this.getPropertyPipe.transform(this.maxTerminationStudent, 'PERSON.LAST_NAME');
                let msdNumber = this.maxTerminationStudent.MSD_NUMBER;
                maxDate = terminationDate;

                this.dateFlags.push({
                    MIN_MAX: 'Maximum',
                    DATE_TYPE: 'Start Date',
                    TYPE: 'Termination',
                    DATE: terminationDate,
                    NAME: studentName,
                    MSD_NUMBER: msdNumber
                });

                if (terminationDate < minDate) {
                    this.creationFlags.push({
                        TYPE: 'Termination',
                        DATE: terminationDate,
                        NAME: studentName,
                        MSD_NUMBER: msdNumber
                    });
                }
            }
        }

        // No future dates
        let today = new Date();
        if (today < minDate) {
            minDate = new Date(this.startDateOptions.defaultMinDate);
            minDate.setDate(minDate.getDate() + 1);
            maxDate = new Date(this.startDateOptions.defaultMinDate);
        } else if (maxDate > new Date()) {
            maxDate = new Date();
        }

        this.startDateOptions.minDate = minDate;
        this.startDateOptions.maxDate = maxDate;
        this.startDateOptions.startAt = minDate;
    }

    setEndDate(startDate?: Date) {
        let currentYear: number = parseInt(this.selectedSchoolYear.substring(0, 4));
        let nextYear: number = currentYear + 1;
        let minDate: Date;
        let maxDate: Date;

        if (this.chosenEnrollmentPeriods && this.chosenEnrollmentPeriods.length > 0 && this.chosenEnrollmentPeriods[0].CODE === 'R') {
            this.endDateOptions.defaultMinDate = new Date(nextYear, 6, 1);
            this.endDateOptions.defaultMaxDate = new Date(nextYear, 7, 31);

            if (this.restrictedDateOptions.minDate) {
                if (this.restrictedDateOptions.minDate > new Date(currentYear, 6, 1)) {
                    minDate = this.restrictedDateOptions.minDate;
                } else {
                    minDate = new Date(currentYear, 6, 1);
                }
            } else {
                minDate = new Date(currentYear, 6, 1);
            }
            if (this.restrictedDateOptions.maxDate) {
                if (this.restrictedDateOptions.maxDate < new Date(nextYear, 7, 31)) {
                    maxDate = this.restrictedDateOptions.maxDate;
                } else {
                    maxDate = new Date(nextYear, 7, 31);
                }
            } else {
                maxDate = new Date(nextYear, 7, 31);
            }
        } else if (this.chosenEnrollmentPeriods && this.chosenEnrollmentPeriods.length > 0 && this.chosenEnrollmentPeriods[0].CODE === 'S') {
            this.endDateOptions.defaultMinDate = new Date(currentYear, 4, 15);
            this.endDateOptions.defaultMaxDate = new Date(nextYear, 8, 20);

            if (this.restrictedDateOptions.maxDate) {
                if (this.restrictedDateOptions.maxDate > new Date(nextYear, 4, 15)) {
                    minDate = this.restrictedDateOptions.maxDate;
                } else {
                    minDate = new Date(nextYear, 4, 15);
                }
            } else {
                minDate = new Date(nextYear, 4, 15);
            }
            maxDate = new Date(nextYear, 8, 20);
        } else if (this.chosenEnrollmentPeriods && this.chosenEnrollmentPeriods.length > 0 && this.chosenEnrollmentPeriods[0].CODE === 'I') {
            this.endDateOptions.defaultMinDate = new Date(currentYear, 6, 1);
            this.endDateOptions.defaultMaxDate = new Date(nextYear, 7, 31);
            this.endDateOptions.defaultMaxDate.setDate(this.startDateOptions.defaultMaxDate.getDate() + 30);

            if (startDate) {
                minDate = startDate;
                maxDate = new Date(startDate);
                maxDate.setDate(startDate.getDate() + 30);
            } else {
                if (this.restrictedDateOptions.minDate) {
                    if (this.restrictedDateOptions.minDate > new Date(currentYear, 6, 1)) {
                        minDate = this.restrictedDateOptions.minDate;
                    } else {
                        minDate = new Date(currentYear, 6, 1);
                    }
                } else {
                    minDate = new Date(currentYear, 6, 1);
                }

                if (this.restrictedDateOptions.maxDate) {
                    if (this.restrictedDateOptions.maxDate < new Date(nextYear, 7, 31)) {
                        maxDate = this.restrictedDateOptions.maxDate;
                    } else {
                        maxDate = new Date(nextYear, 7, 31);
                        maxDate.setDate(maxDate.getDate() + 30);
                    }
                } else {
                    maxDate = new Date(nextYear, 7, 31);
                    maxDate.setDate(maxDate.getDate() + 30);
                }
            }
        } else {
            this.endDateOptions.defaultMinDate = new Date(currentYear, 6, 1);
            this.endDateOptions.defaultMaxDate = new Date(nextYear, 7, 31);
            minDate = new Date(currentYear, 6, 1);
            maxDate = new Date(nextYear, 7, 31);
        }

        if (this.maxEndOfEligibilityStudent && this.maxTerminationStudent) {
            let eoeDate = this.cleanDatePipe.transform(
                this.getPropertyPipe.transform(this.maxEndOfEligibilityStudent, 'SCHOOL_ENROLLMENT_DETAILS[0].STUDENT_ELIGIBILITIES[0].ELIGIBILITY_END_DATE')
            );
            let terminationDate = this.cleanDatePipe.transform(
                this.getPropertyPipe.transform(this.maxTerminationStudent, 'STUDENT_TERMINATION_STATUSES[0].STATUS_DATE')
            );

            if (eoeDate <= terminationDate) {
                if (eoeDate < maxDate) {
                    maxDate = eoeDate;
                }
            } else {
                if (terminationDate < maxDate) {
                    maxDate = terminationDate;
                }
            }
        } else if (this.maxEndOfEligibilityStudent) {
            let eoeDate = this.cleanDatePipe.transform(
                this.getPropertyPipe.transform(this.maxEndOfEligibilityStudent, 'SCHOOL_ENROLLMENT_DETAILS[0].STUDENT_ELIGIBILITIES[0].ELIGIBILITY_END_DATE')
            );
            if (eoeDate < maxDate) {
                maxDate = eoeDate;
            }
        } else if (this.maxTerminationStudent) {
            let terminationDate = this.cleanDatePipe.transform(
                this.getPropertyPipe.transform(this.maxTerminationStudent, 'STUDENT_TERMINATION_STATUSES[0].STATUS_DATE')
            );
            if (terminationDate < maxDate) {
                maxDate = terminationDate;
            }
        }

        if (startDate && minDate < startDate) {
            minDate = startDate;
        }

        let today = new Date();
        if (today < minDate) {
            minDate = new Date(this.endDateOptions.defaultMinDate);
            minDate.setDate(minDate.getDate() + 1);
            maxDate = new Date(this.endDateOptions.defaultMinDate);
        } else if (maxDate > new Date()) {
            maxDate = new Date();
        }

        this.endDateOptions.minDate = minDate;
        this.endDateOptions.maxDate = maxDate;
        this.endDateOptions.startAt = minDate;
    }

    // Help Text
    displayHelpText(qId: number) {
        const dialogConfig = new MatDialogConfig();
        dialogConfig.autoFocus = true;
        dialogConfig.maxHeight = '80vh';
        dialogConfig.data = this.returnHelpText(qId);
        const dialogRef = this.dialog.open(HelpTextComponent, dialogConfig);
    }

    returnHelpText(qId: number): string {
        let questionHelpText = this.lstQuestionHelpText.find((x) => x.QUESTIONS_ID == qId);

        if (questionHelpText) return questionHelpText?.HELP_TEXT;
        else return '';
    }

    /**************************************************************************************************************************
     * Confirmation pop-up for adding
     **************************************************************************************************************************/
    confirmPopup() {
        this.msg = new MsgModel();
        if (this.checkValid()) {
            if (this.students.length > 0) {
                var text =
                    '<h3>' +
                    this.studentServices.length +
                    ' Services will be updated for ' +
                    this.getCheckStudentsLength(this.students) +
                    ' child(ren)</h3><br/>' +
                    '<div class="row">' +
                    '<div>' +
                    '<label>Start Date: &nbsp;</label>' +
                    (this.simpleDatePipe.transform(this.form.get('startDate')!.value)
                        ? this.simpleDatePipe.transform(this.form.get('startDate')!.value)
                        : '(No Update)') +
                    '</div>' +
                    '<div>' +
                    '<label>End Date: &nbsp;</label>' +
                    (this.simpleDatePipe.transform(this.form.get('endDate')!.value)
                        ? this.simpleDatePipe.transform(this.form.get('endDate')!.value)
                        : '(No Update)') +
                    '</div>' +
                    '</div>';

                Swal.fire({
                    title: 'Service Confirmation',
                    html: text,
                    showConfirmButton: true,
                    showCancelButton: true,
                    confirmButtonColor: '#3a6b35',
                    confirmButtonText: 'Confirm',
                    cancelButtonText: 'Cancel'
                }).then((result) => {
                    if (result.isConfirmed) {
                        return this.submit();
                    }
                });
            } else {
                this.msg.SUCCESS = false;
                this.msg.MSG = 'Error updating service dates. Please try again.';

                this.isLoading = false;
            }
        } else {
            // this.msg.SUCCESS = false;
            // this.msg.MSG = 'Error, please check your inputs.';
            // this.isLoading = false;
        }
    }

    getCheckStudentsLength = function (students: Student[]) {
        let uniqueStudents = students.filter((student, index, self) => index === self.findIndex((s) => s.ID === student.ID));

        return uniqueStudents ? uniqueStudents.length : 0;
    };

    /**************************************************************************************************************************
     * Tracking History
     **************************************************************************************************************************/
    initCurrentChanges() {
        // Static Form Group
        this.formChanges['startDate'] = { CHANGED_FIELD: 'Start Date', VALUE: '', CHANGED_VALUE: '' };
        this.formChanges['endDate'] = { CHANGED_FIELD: 'End Date', VALUE: '', CHANGED_VALUE: '' };
    }

    setCurrentChanges() {
        // Static Form Group
        this.formChanges['startDate'].VALUE = this.form.get('startDate')?.value;
        this.formChanges['endDate'].VALUE = this.form.get('endDate')?.value;

        // Set same value
        Object.keys(this.formChanges).forEach((key) => {
            this.formChanges[key].CHANGED_VALUE = this.formChanges[key].VALUE;
        });
    }

    updateDataSource() {
        setTimeout(() => {
            // Data
            this.tableDataSource = new MatTableDataSource<any>();
            this.tableDataSource.data = this.generateCurrentChangesTable();

            // Filter
            this.tableDataSource.filterPredicate = (data: any, filter) => {
                //const dataStr = JSON.stringify(data).toLowerCase();
                //return dataStr.indexOf(filter) != -1;
                return data.CHANGED;
            };

            // Will always run the filterPredicate when filter has a value in it
            this.tableDataSource.filter = 'changed_only';
        });
    }

    generateCurrentChangesTable() {
        let result: any[] = [];

        // Form Group
        Object.keys(this.formChanges).forEach((key) => {
            let CHANGED_FIELD = this.formChanges[key].CHANGED_FIELD;
            let VALUE = this.formChanges[key].VALUE;
            let CHANGED_VALUE = this.formChanges[key].CHANGED_VALUE;

            if (typeof VALUE === 'object' && !Array.isArray(VALUE) && VALUE !== null) {
                if (VALUE['NAME']) {
                    VALUE = VALUE['NAME'];
                }
                // County
                else if (VALUE['COUNTY_NAME']) {
                    VALUE = VALUE['COUNTY_NAME'];
                }
                // District
                else if (VALUE['DISTRICTS']) {
                    VALUE = VALUE['DISTRICTS'];
                }
                // Grade
                else if (VALUE['GRADES']) {
                    VALUE = VALUE['GRADES'];
                }
                // COS Type
                else if (VALUE['REASON']) {
                    VALUE = VALUE['REASON'];
                }
            }
            if (typeof CHANGED_VALUE === 'object' && !Array.isArray(CHANGED_VALUE) && CHANGED_VALUE !== null) {
                if (CHANGED_VALUE['NAME']) {
                    CHANGED_VALUE = CHANGED_VALUE['NAME'];
                }
                // County
                else if (CHANGED_VALUE['COUNTY_NAME']) {
                    CHANGED_VALUE = CHANGED_VALUE['COUNTY_NAME'];
                }
                // District
                else if (CHANGED_VALUE['DISTRICTS']) {
                    CHANGED_VALUE = CHANGED_VALUE['DISTRICTS'];
                }
                // Grade
                else if (CHANGED_VALUE['GRADES']) {
                    CHANGED_VALUE = CHANGED_VALUE['GRADES'];
                }
                // COS Type
                else if (CHANGED_VALUE['REASON']) {
                    CHANGED_VALUE = CHANGED_VALUE['REASON'];
                }
            }

            switch (CHANGED_FIELD) {
                case 'Start Date':
                case 'End Date':
                    let dateValue = this.simpleDatePipe.transform(VALUE);
                    let changedDateValue = this.simpleDatePipe.transform(CHANGED_VALUE);
                    if (dateValue !== changedDateValue) {
                        result.push({
                            CHANGED_FIELD: CHANGED_FIELD,
                            VALUE: dateValue,
                            CHANGED_VALUE: changedDateValue,
                            CHANGED: true
                        });
                    }
                    break;
                default:
                    result.push({
                        CHANGED_FIELD: CHANGED_FIELD,
                        VALUE: VALUE,
                        CHANGED_VALUE: CHANGED_VALUE,
                        CHANGED: VALUE !== CHANGED_VALUE
                    });
                    break;
            }
        });

        return result;
    }

    /**************************************************************************************************************************
     * Change Functions
     **************************************************************************************************************************/
    startDateChange() {
        this.errorMsg = new MsgModel();
        this.errorMsg.SUCCESS = true;

        if (!this.form.get('startDate')?.value) {
            this.setDates();
        }

        if (this.form.get('endDate')?.value) {
        } else {
            // Needs to be before All End Dates if given no end date
            let currentStartDate = this.form.get('startDate')?.value;
            let invalidStudentService = this.studentServices.find((student) => {
                if (new Date(currentStartDate) > new Date(student.STUDENT_SERVICE.END_DATE)) {
                    this.errorMsg.SUCCESS = false;
                    this.errorMsg.MSG =
                        'The Start Date needs to be before End Date: ' +
                        this.simpleDatePipe.transform(new Date(student.STUDENT_SERVICE.END_DATE)) +
                        ' (' +
                        student.MSD_NUMBER +
                        ').';
                }
            });
        }
    }

    endDateChange() {
        this.errorMsg = new MsgModel();
        this.errorMsg.SUCCESS = true;

        if (!this.form.get('endDate')?.value) {
            this.setDates();
        }

        if (this.form.get('startDate')?.value) {
        } else {
            // Needs to be on or after All Start Dates if no given start date
            let currentEndDate = this.form.get('endDate')?.value;
            let invalidStudentService = this.studentServices.find((student) => {
                if (new Date(currentEndDate) < new Date(student.STUDENT_SERVICE.START_DATE)) {
                    this.errorMsg.SUCCESS = false;
                    this.errorMsg.MSG =
                        'The End Date needs to be on or after Start Date: ' +
                        this.simpleDatePipe.transform(new Date(student.STUDENT_SERVICE.START_DATE)) +
                        ' (' +
                        student.MSD_NUMBER +
                        ').';
                }
            });
        }
    }
    buildUniqueStudents() {
        this.uniqueStudents = this.resolveDuplicateStudents(this.students);
    }

    resolveDuplicateStudents(students: any[]) {
        let uniques = [...new Map(students.map((s) => [s['ID'], s])).values()];

        return uniques;
    }

    updateSelectedChildrenDataSource(newSort?: boolean) {
        setTimeout(() => {
            // Data
            let dataSource = new MatTableDataSource<any>();
            dataSource.data = this.students.filter((student, index, self) => index === self.findIndex((s) => s.ID === student.ID));

            // Paginator
            dataSource.paginator = this.paginators.toArray()[0];

            // Sort
            dataSource.sort = this.sorts.toArray()[0];
            dataSource.sortingDataAccessor = (obj, property) => this.getPropertyPipe.transform(obj, property, true);
            if (newSort) {
                const defaultSort: Sort = { active: 'MSD_NUMBER', direction: 'asc' };
                dataSource.sort.active = defaultSort.active;
                dataSource.sort.direction = defaultSort.direction;
                dataSource.sort.sortChange.emit(defaultSort);
            } else {
                dataSource.sort.sortChange.emit(this.sorts.toArray()[0]);
            }
            // Filter
            dataSource.filterPredicate = (data: any, filter) => {
                const dataStr = JSON.stringify(data).toLowerCase();
                return dataStr.indexOf(filter) != -1;
            };

            this.selectedChildrenTableDataSource = dataSource;
        }, 100);
    }

    setSelectedChildrenFilter() {
        this.selectedChildrenTableDataSource.filter = this.selectedChildrenFilter.trim().toLocaleLowerCase();
    }

    toggleAllStudents() {
        if (this.hasAtLeastOneStudent()) {
            this.students.forEach((student: any) => {
                student.ENABLED = false;
            });
        } else {
            this.students.forEach((student: any) => {
                student.ENABLED = true;
            });
        }

        this.studentLength = this.resolveOnlyChosenStudents().length;

        this.setEligibilityAndTerminationRestrictions(this.resolveOnlyChosenMissingEoEStudents());
        this.restrictDates();
        this.setDates();
    }

    toggleStudent(student: any) {
        if (!student.GRADUATED) {
            student.ENABLED = !student.ENABLED;
        }

        this.studentLength = this.resolveOnlyChosenStudents().length;

        this.setEligibilityAndTerminationRestrictions(this.resolveOnlyChosenMissingEoEStudents());
        this.restrictDates();
        this.setDates();
    }

    hasAtLeastOneStudent() {
        let found = false;

        found = this.students.find((student: any) => student.ENABLED);

        return !!found;
    }

    hasDifferentCounts() {
        return this.uniqueStudents.length !== this.resolveOnlyChosenStudents().length;
    }

    resolveOnlyChosenStudents() {
        let returnStudents = JSON.parse(JSON.stringify(this.uniqueStudents));

        returnStudents = returnStudents.filter((student: any) => {
            return student.ENABLED;
        });

        return returnStudents;
    }

    resolveOnlyChosenMissingEoEStudents() {
        let returnStudents = JSON.parse(JSON.stringify(this.uniqueStudents));

        returnStudents = returnStudents.filter((student: any) => {
            return student.ENABLED;
        });

        let mergedStudents = returnStudents.map((s: any) => {
            let missingEoEStudents = this.missingEoEStudents.find((eoeStudent) => eoeStudent.ID === s.ID);
            return { ...s, ...missingEoEStudents };
        });

        return mergedStudents;
    }

    resolveOnlyChosenStudentServices() {
        let returnStudents = JSON.parse(JSON.stringify(this.uniqueStudents));

        returnStudents = returnStudents.filter((student: any) => {
            return student.ENABLED;
        });

        let mergedStudents = returnStudents.map((s: any) => {
            let studentServices = this.studentServices.find((studentService) => studentService.ID === s.ID);
            return { ...s, ...studentServices };
        });

        return mergedStudents;
    }
}
